// example query path
// http://localhost:3000/search?agentId=asdo&agencyId=asdo&areaId=asdo&priceMin=asdo&priceMax=asdo&houseSizeMin=asdo&houseSizeMax=asdo&plotSizeMin=asdo&plotSizeMax=asdo&roomCountMin=asdo&transactionalType=asdo&propertyType=asdo&isNewBuild=asdo&hasPool=asdo&isPetFriendly=asdo&hasGarden=asdo&hasFlatlet=asdo&isSecurityEstate=asdo&isRetiermentVillage=asdo&isOnAuction=asdo// ?agentId=asdo&agencyId=asdo&areaId=asdo&priceMin=asdo&priceMax=asdo&houseSizeMin=asdo&houseSizeMax=asdo&plotSizeMin=asdo&plotSizeMax=asdo&roomCountMin=asdo&transactionalType=asdo&propertyType=asdo&isNewBuild=asdo&hasPool=asdo&isPetFriendly=asdo&hasGarden=asdo&hasFlatlet=asdo&isSecurityEstate=asdo&isRetiermentVillage=asdo&isOnAuction=asdo

import { FullProperty } from "./fullProperty";

export interface DistanceSearchItem {
    restaurant: FullProperty;
    distance: number;
    isClosed: boolean;

}

class SearchListingsQuery {
    query: string = "";
    currentPage: number = 0;

    private static stringToBool(str: string | null, def: boolean): boolean {
        if (str === null && def !== null) {
            return def;
        }
        if (str === "true") {
            return true;
        }
        return false;
    }

    public static transformFromQueryParams(query: URLSearchParams): SearchListingsQuery {
        var searchQuery = new SearchListingsQuery();
        searchQuery.query = query.get("query") ?? "";
        searchQuery.currentPage = Number.parseFloat(query.get("currentPage") ?? "0")
    return searchQuery;
    }
}

export { SearchListingsQuery };